import Vue from 'vue';
import { DateTime, Settings } from 'luxon';

Settings.defaultLocale = 'nl';

Vue.prototype.$dateTime = window.dateTime = DateTime;
